import { render, staticRenderFns } from "./ChannelSideOnline.vue?vue&type=template&id=a1a94302&scoped=true"
import script from "./ChannelSideOnline.vue?vue&type=script&lang=js"
export * from "./ChannelSideOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a94302",
  null
  
)

export default component.exports